import React, { useState, useEffect } from 'react';
import { Modal, Avatar, Button, Tag, Row, Col, Card, Divider, Input, Form, Select, Switch, message, Popover, List, Tabs } from 'antd';
import { EditOutlined, CloseOutlined, CheckOutlined, SaveOutlined, CheckCircleTwoTone, UserOutlined, PhoneOutlined, MailOutlined, BankOutlined, IdcardOutlined, TeamOutlined, CrownOutlined, DeleteOutlined, ExclamationCircleTwoTone, PlusOutlined, CommentOutlined } from '@ant-design/icons';
import '../../requestLists/components/userDetailsModal/UserDetailsModal.scss';

import { GetCountries, GetState } from 'react-country-state-city';
import { useSelector } from 'react-redux';
import TextArea from 'antd/es/input/TextArea';
import { useDispatch } from 'react-redux';

import { Toast } from 'react-toastify/dist/components';
import { toast } from 'react-toastify';
import { appDispatch, RootState } from '../../../../app/store';
import { DEFAULT_PROFILE_IMAGE } from '../../../../constants';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from 'react-chartjs-2';
import { fetchSystemMetricsList } from '../../../../features/members/membersSlice';

ChartJS.register(ArcElement, Tooltip, Legend)


const { Option } = Select;

interface UserData {
  id: number;
  first_name: string;
  last_name: string;
  display_name: string;
  network_name: string;
  email: string;
  email_pref: number;
  pager_number: string;
  pager_pref: number;
  profile_pic: string;
  site_count: number;
  user_capacity: any;
  user_type: string;
  source_of_reg_request: string;
  approval_status: string;
  network_roles: number[];
  network_specialties: number[];
  description: any;
  subscription: any;
  practice_sites: Array<{
    name: string;
    phone_number_country_code: string;
    phone_number: string;
    position: string;
    country: { name: string; country_name_code: string };
    state: { name: string; country_name_code: string };
    city: { name: string; country_name_code: string };
    address_one: string;
    address_two: string;
    address_three: string;
  }>;
  medical_licenses: Array<{
    license_number: string;
    country: { name: string; country_name_code: string };
    issuing_state: { name: string; state_code: string };
    is_valid: boolean;
    validation_status: string;
    comment?: string;
  }>;
  contact_info: Array<{
    country_code: string;
    number: string;
    pref: number;
    number_type: string;
    number_status: string;
  }>;
  membership_plan: Array<{
    subscription_plan: {
      name: string;
      price: string;
      currency: string;
    };


  }>;
}

interface UserDetailsModalProps {
  fromMemberPage?: boolean
  isVisible: boolean;
  user: UserData | null;
  onClose: () => void;
  onAccept: (user: UserData, isApprove: boolean, Reason?: string) => void;
  onReject: (user: UserData, isApprove: boolean, Reason?: string) => void;
  currentTab?: string;
  onEdit: (user: UserData) => void;
  onDelete: (user: UserData) => void;
  onVerifyLicense?: (user: UserData, licenseIndex: number) => void;
  onRejectLicense?: (user: UserData, licenseIndex: number, reason: string) => void;
  onEditLicense?: (user: UserData, licenseIndex: number, updatedLicense: UserData['medical_licenses'][number]) => void;
  onSaveLicense?: (user: UserData, licenseIndex: number, updatedLicense: UserData['medical_licenses'][number]) => void;
  isLicenseActionLoading?: boolean;
  isEditLicenseLoading?: boolean;
}

export const NetworkDetailsModal: React.FC<UserDetailsModalProps> = ({
  fromMemberPage,
  isVisible,
  user,
  onClose,
  onAccept,
  onReject,
  currentTab,
  onEdit,
  onDelete,
  onVerifyLicense,
  onRejectLicense,
  onEditLicense,
  onSaveLicense,
  isLicenseActionLoading = false,
  isEditLicenseLoading = false
}) => {
  console.log(user, "useruser")


  const dispatch = useDispatch<appDispatch>();

  // License action loading states


  const systemMetricsData = useSelector(
    (state: RootState) => state.members.fetchSystemMetricsList.fetchSystemMetricsListData) || [];

  const DBMetricsData = useSelector(
    (state: RootState) => state.members.fetchDBMetricsList.fetchDBMetricsListData) || [];


  const cpuUsage = systemMetricsData?.CPU_Usage || 0;
  const ramUsed = systemMetricsData?.RAM_Used_GB || 0;
  const storageUsed = systemMetricsData?.Storage_Used_GB || 0;
  const dbUsed = DBMetricsData?.size_pretty?.replace(/[^\d.]/g, "") || "0"




  useEffect(() => {

    const thunkArgs = {

    }
    dispatch(fetchSystemMetricsList(thunkArgs))
  }, [isVisible])

  const metrics = {
    "CPU_Usage_%": systemMetricsData?.CPU_Usage,
    "RAM_Used_GB": systemMetricsData?.RAM_Used_GB,
    "Storage_Used_GB": systemMetricsData?.Storage_Used_GB,
  };

  const buildPieData = (usedValue: any, label: any) => ({
    labels: ["Used", "Remaining"],
    datasets: [
      {
        label,
        data: [usedValue, 100 - usedValue],
        backgroundColor: ["#a16b0e", "#1a865f"],
        hoverOffset: 6,
      },
    ],
  });


  const cpuPieData = buildPieData(cpuUsage, "CPU Usage (%)");
  const ramPieData = buildPieData(ramUsed, "RAM Usage (%)");
  const storagePieData = buildPieData(storageUsed, "Storage Usage (%)");
  const dbPieData = buildPieData(dbUsed, "DB Usage(MB)")

  const pieData = {
    labels: ["CPU Usage (%)", "RAM Used (GB)", "Storage Used (GB)"],
    datasets: [
      {
        label: "System Metrics",
        data: [
          metrics["CPU_Usage_%"],
          metrics["RAM_Used_GB"],
          metrics["Storage_Used_GB"],
        ],
        backgroundColor: ["#4554fa", "#1a865f", "#a16b0e"],
        hoverOffset: 8,
      },
    ],
  };


  const pieOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
    },
  };

  return (

    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={"75%"}
      className="user-details-modal fixed-height-modal"
      centered={true}
      bodyStyle={{
        padding: '24px',
        background: 'var(--modal-background-color)',
        height: '600px',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: 'Network Information',
            children: (
              user && (
                <div className="user-details-content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <div className="modal-scroll-content" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: ".75rem", minHeight: 0 }}>
                    {/* Profile Summary Section */}
                    <Row gutter={[24, 24]} className="profile-section">
                      <Col sm={24} md={24} lg={12} xl={12}>

                        <Card
                          title={
                            <div className="card-title" style={{ color: 'var(--common-black-white)', display: "flex", alignItems: "center", gap: "8px" }}>
                              <TeamOutlined className="card-icon role-icon" />
                              Network Details
                            </div>
                          }
                          size="small"
                          className="info-card"
                          style={{
                            background: 'var(--common-dashboard-card-background-color)',
                            minHeight: '9.5rem',
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                          headStyle={{ background: 'var(--country-dropdown-hover)', color: 'white', borderBottom: '1px solid var(--border-color-primary),' }}
                          bodyStyle={{
                            padding: '20px',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <Row gutter={[24, 12]}>
                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>Network Name</div>
                                <div className="info-value">
                                  <div style={{ color: 'var(--font-color-primary)' }} className="info-value">{user.network_name}</div>
                                </div>

                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>Description</div>
                                <div className="info-value">
                                  <div style={{ color: 'var(--font-color-primary)' }} className="info-value">{user.description}
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>Site Count</div>
                                <div className="info-value">
                                  <div style={{ color: 'var(--font-color-primary)' }} className="info-value">{user.site_count}
                                  </div>
                                </div>
                              </div>
                            </Col>



                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>User Capacity</div>
                                <div className="info-value">
                                  <div style={{ color: 'var(--font-color-primary)' }} className="info-value" >{user.user_capacity}
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Card>

                      </Col>


                      {/* Membership Plan */}
                      <Col sm={24} md={24} lg={12} xl={12}>

                        <Card
                          title={
                            <div className="card-title" style={{ color: 'var(--common-black-white)', display: "flex", alignItems: "center", gap: "8px" }}>
                              <CrownOutlined className="card-icon membership-icon" />
                              Membership and Payment Plan
                            </div>
                          }
                          size="small"
                          className="info-card"
                          style={{
                            background: 'var(--common-dashboard-card-background-color)',
                            minHeight: '9.5rem',
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                          headStyle={{ background: 'var(--country-dropdown-hover)', color: 'white', borderBottom: '1px solid var(--border-color-primary),' }}
                          bodyStyle={{
                            padding: '20px',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                          }}
                        >
                          <Row gutter={[24, 12]}>
                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>Plan Name</div>
                                <div className="info-value">
                                  <Tag color="#4554fa" className="plan-tag">
                                    {user?.subscription?.plan?.name}
                                  </Tag>
                                </div>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>Price</div>
                                <div className="info-value price-value" style={{ color: 'var(--font-color-primary)' }}>
                                  {user?.subscription?.plan?.price} {user?.subscription?.plan?.currency}
                                </div>
                              </div>
                            </Col>

                          </Row>
                        </Card>
                      </Col>
                    </Row>
                    <Row gutter={[24, 24]} className="info-grid">
                      <Col sm={24} md={24} lg={12} xl={12}>

                        <Card
                          title={
                            <div
                              className="card-title"
                              style={{
                                color: 'var(--common-black-white)',
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <CrownOutlined className="card-icon membership-icon" />
                              Renewal Information
                            </div>
                          }
                          size="small"
                          className="info-card"
                          style={{
                            background: 'var(--common-dashboard-card-background-color)',
                            minHeight: '9.5rem',
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                          headStyle={{
                            background: 'var(--country-dropdown-hover)',
                            color: 'white',
                            borderBottom: '1px solid var(--border-color-primary)',
                          }}
                          bodyStyle={{
                            padding: '20px',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                          }}
                        >
                          <Row gutter={[24, 12]}>
                            {/* Renewal Date */}
                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>
                                  Renewal Date
                                </div>
                                <div className="info-value">{"N/A"}</div>
                              </div>
                            </Col>

                            {/* Renewal Fee */}
                            <Col span={12}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>
                                  Renewal Fee
                                </div>
                                <div className="info-value price-value" style={{ color: 'var(--font-color-primary)' }}>
                                  {"N/A"}
                                </div>
                              </div>
                            </Col>

                            {/* Terms of Renewal - Full Width */}
                            <Col span={24}>
                              <div className="info-item">
                                <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>
                                  Terms of Renewal
                                </div>
                                <div className="info-value" style={{ color: 'var(--font-color-primary)', textAlign: "justify" }}>
                                  {
                                    "This agreement shall automatically renew for successive one-year terms unless either party provides written notice of non-renewal at least 30 days prior to the end of the current term."
                                  }
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Card>

                      </Col>


                      <Col sm={24} md={24} lg={12} xl={12}>
                        <Card
                          title={
                            <div
                              className="card-title"
                              style={{
                                color: 'var(--common-black-white)',
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <PhoneOutlined className="card-icon" />
                              Contact Information
                            </div>
                          }
                          size="small"
                          className="info-card"
                          style={{
                            background: 'var(--common-dashboard-card-background-color)',
                            minHeight: '9.5rem',
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                          headStyle={{
                            background: 'var(--country-dropdown-hover)',
                            color: 'white',
                            borderBottom: '1px solid var(--border-color-primary)',
                          }}
                          bodyStyle={{
                            padding: '20px',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                          }}
                        >
                          {user?.contact_info && user.contact_info.length > 0 ? (
                            user.contact_info.map((contact: any, index: number) => (
                              <Row gutter={[24, 12]} key={index} style={{ marginBottom: '10px' }}>
                                <Col span={8}>
                                  <div className="info-item">
                                    <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>
                                      Country Code
                                    </div>
                                    <div className="info-value" style={{ color: 'var(--font-color-primary)' }}>
                                      +{contact.country_code}
                                    </div>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div className="info-item">
                                    <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>
                                      Phone Number
                                    </div>
                                    <div className="info-value" style={{ color: 'var(--font-color-primary)' }}>
                                      {contact.number}
                                    </div>
                                  </div>
                                </Col>
                                <Col span={8}>
                                  <div className="info-item">
                                    <div className="info-label" style={{ color: 'var(--font-color-primary)' }}>
                                      Type
                                    </div>
                                    <div className="info-value" style={{ color: 'var(--font-color-primary)' }}>
                                      {contact.number_type}
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            ))
                          ) : (
                            <div style={{ color: 'var(--font-color-primary)', textAlign: "center" }}>No Contact Information Available</div>
                          )}
                        </Card>
                      </Col>

                    </Row>


                  </div>
                </div>
              )
            ),
          },
          // {
          //   key: '2',
          //   label: 'System Metrics',
          //   children: (
          //     <div
          //       style={{
          //         width: "100%",
          //         height: "400px",
          //         display: "flex",
          //         justifyContent: "center",
          //         alignItems: "center",
          //         overflow: "hidden",
          //       }}
          //     >
          //       <div style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
          //         <div style={{ width: "250px" }}>
          //           <h3>CPU Usage</h3>
          //           <Pie data={cpuPieData} />
          //         </div>

          //         <div style={{ width: "250px" }}>
          //           <h3>RAM Used</h3>
          //           <Pie data={ramPieData} />
          //         </div>

          //         <div style={{ width: "250px" }}>
          //           <h3>Storage Used</h3>
          //           <Pie data={storagePieData} />
          //         </div>


          //         <div style={{ width: "250px" }}>
          //           <h3>Database Usage</h3>
          //           <Pie data={dbPieData} />
          //         </div>
          //       </div>
          //     </div>
          //   ),
          // },
        ]}
      />
    </Modal>
  );
}; 